import { ref } from "vue";
import type { LoadingOverlayOptions } from "~/components/Atoms/Dialog/LoadingOverlay.vue";
import LoadingOverlay from "~/components/Atoms/Dialog/LoadingOverlay.vue";

/**
 * useLoadingOverlay composable
 * Provides open/close API for LoadingOverlay component
 */
export const useLoadingOverlay = () => {
  const loadingOverlayRef = ref<InstanceType<typeof LoadingOverlay> | null>(null);

  const open = (options: LoadingOverlayOptions = {}) => {
    if (!loadingOverlayRef.value) {
      consoleError("LoadingOverlay component is not mounted yet");
      return;
    }
    loadingOverlayRef.value.open(options);
  };

  const close = () => {
    if (!loadingOverlayRef.value) {
      consoleError("LoadingOverlay component is not mounted yet");
      return;
    }
    loadingOverlayRef.value.close();
  };

  const setRef = (refInstance: any) => {
    loadingOverlayRef.value = refInstance;
  };

  return {
    open,
    close,
    setRef,
  };
};

const loadingOverlayInstance = useLoadingOverlay();
export default loadingOverlayInstance;
